export const TYPE = {
  // COLOR
  ITEM_COLOR: 'ItemColor',
  COLOR_NAME_PRIMARY: 'ColorNamePrimary',
  COLOR_FINISH_PRIMARY: 'ColorFinishPrimary',
  COLOR_NAME_SECONDARY: 'ColorNameSecondary',
  COLOR_FINISH_SECONDARY: 'ColorFinishSecondary',
  ITEM_COLOR_CODE: 'ItemColorCode',
  ITEM_PRIMARY_COLOR_RGB: 'ItemPrimaryColorRGB',
  ITEM_SECONDARY_COLOR_RGB: 'ItemSecondaryColorRGB',
  SELECT_COLOR: 'SelectColor',
  SELECT_ITEM_GENDER_FRAME: 'SelectItemGenderFrame',
  // FRAMESIZE
  ITEM_FRAME_SIZE_CODE: 'ItemFrameSizeCode',
  // FRAME
  ITEM_FRAME_TYPE: 'ItemFrameType',
  ITEM_GENDER_FRAME: 'ItemGenderFrame',
  GEOMETRY_FRAME_NAME: 'GeometryFrameName',
  // BRAND
  PRODUCT_BRAND: 'ProductBrand',
  ITEM_BRAND: 'ItemBrand',
  // SPECS
  ITEM_BATTERY_RANGE: 'ItemBatteryRange',
  ITEM_CHARGER_DESCRIPTION: 'ItemChargerDescription',
  PRODUCT_ACCESSORIES: 'ProductAccessories',
  PRODUCT_DISC_BRAKE_ROTOR_FRONT: 'ProductDiscBrakeRotorFront',
  // PRODUCT_DISC_BRAKE_ROTOR_BACK: 'ProductDiscBrakeRotorBack',
  PRODUCT_DISC_BRAKE_ROTOR_REAR: 'ProductDiscBrakeRotorRear',
  // ITEM_PEDAL_DESCRIPTION: 'ItemPedalDescription',
  // ITEM_FRAME_SIZE_CODE: 'ItemFrameSizeCode',
  ITEM_FRAME_SIZE_CM: 'ItemFrameSizeCm',
  PRODUCT_DRIVE_TRAIN: 'ProductDriveTrain',
  PRODUCT_GROUPSET: 'ProductGroupset',
  PRODUCT_GEAR_SYSTEM_DESCRIPTION: 'ProductGearSystemDescription',
  // PRODUCT_BAREND: 'ProductBarend',
  PRODUCT_WHEELSET: 'ProductWheelset',
  PRODUCT_KICKSTAND_DESCRIPTION: 'ProductKickstandDescription',
  ITEM_LOCK_DESCRIPTION: 'ItemLockDescription',
  PRODUCT_MAX_TOTAL_WEIGHT_KG: 'ProductMaxTotalWeightKg',
  ITEM_FRAME_DESCRIPTION: 'ItemFrameDescription',
  ITEM_FORK_DESCRIPTION: 'ItemForkDescription',
  PRODUCT_FRAME_STORAGE: 'ProductFrameStorage',
  ITEM_HANDLEBAR_DESCRIPTION: 'ItemHandlebarDescription',
  ITEM_SADDLE_DESCRIPTION: 'ItemSaddleDescription',
  ITEM_SEATPOST_DESCRIPTION: 'ItemSeatpostDescription',
  ITEM_STEM_DESCRIPTION: 'ItemStemDescription',
  PRODUCT_BRAKE_SYSTEM: 'ProductBrakeSystem',
  PRODUCT_CRANKSET: 'ProductCrankset',
  ITEM_SPROCKET_DESCRIPTION: 'ItemSprocketDescription',
  ITEM_TRANSMISSION_OF_DRIVE: 'ItemTransmissionOfDrive',
  PRODUCT_WHEEL_RIM_DESCRIPTION: 'ProductWheelRimDescription',
  // PRODUCT_BRAKE_LEVER_DESCRIPTION: 'ProductBrakeLeverDescription',
  ITEM_CARRIER_FRONT: 'ItemCarrierFront',
  ITEM_CARRIER_REAR: 'ItemCarrierRear',
  PRODUCT_LIGHTS_FRONT_TYPE: 'ProductLightsFrontType',
  PRODUCT_LIGHTS_REAR_TYPE: 'ProductLightsRearType',
  EBIKE_BATTERY_NAME: 'EbikeBatteryName',
  ITEM_BATTERY_WATT_HOURS: 'ItemBatteryWattHours',
  EBIKE_DISPLAY_DESCRIPTION: 'EbikeDisplayDescription',
  EBIKE_MOTOR_DESCRIPTION: 'EbikeMotorDescription',
  // ITEM_COLOR: 'ItemColor',
  ITEM_TRAVEL_FORK: 'ItemTravelFork',
  ITEM_TRAVEL_FRAME: 'ItemTravelFrame',
  ITEM_FRONT_HUB: 'ItemFrontHub',
  ITEM_REAR_HUB: 'ItemRearHub',
  PRODUCT_FENDER_DESCRIPTION: 'ProductFenderDescription',
  ITEM_GRIP_DESCRIPTION: 'ItemGripDescription',
  // ITEM_LIGHTS_POWERED_BY: 'ItemLightsPoweredBy',
  PRODUCT_CHAINCASE_DESCRIPTION: 'ProductChaincaseDescription',
  PRODUCT_REAR_DERAILLEUR: 'ProductRearDerailleur',
  ITEM_TIRE_DESCRIPTION: 'ItemTireDescription',
  ITEM_TIRE_REAR_DESCRIPTION: 'ItemTireRearDescription',
  PRODUCT_BOTTOM_BRACKET: 'ProductBottomBracket',
  PRODUCT_BRAKE_LEVER_DESCRIPTION: 'ProductBrakeLeverDescription',
  PRODUCT_SHIFTER: 'ProductShifter',
  ITEM_ROTOR_DESCRIPTION: 'ItemRotorDescription',
  BRAKE_FRONT_BRAKE_SYSTEM_DESCRIPTION: 'BrakeFrontBrakeSystemDescription',
  PRODUCT_REAR_BRAKE_DESCRIPTION: 'ProductRearBrakeDescription',
  PRODUCT_WHEEL_SPOKE_DESCRIPTION: 'ProductWheelSpokeDescription',
  // PRODUCT_STEER_BELL_DESCRIPTION: 'ProductSteerBellDescription',
  PRODUCT_CHAIN_DESCRIPTION: 'ProductChainDescription',
  PRODUCT_FRONT_DERAILLEUR: 'ProductFrontDerailleur',
  PRODUCT_SEGMENT: 'ProductSegment',
  ITEM_FILTER_COLOR: 'ItemFilterColor',
  ITEM_WHEEL_SIZE_INCH: 'ItemWheelSizeInch',
  EBIKE_ENGINE_MODEL: 'EbikeEngineModel',
  EBIKE_SYSTEM_BRAND: 'EbikeSystemBrand',
  EBIKE_SYSTEM_AND_MODEL: 'EbikeSystemAndModel',
  PRODUCT_E_BIKE: 'ProductEBike',
  PRODUCT_MAIN_CATEGORY: 'ProductMainCategory',
  PRODUCT_BIDEX_COMMODITY_GROUP: 'ProductBidexCommodityGroup',
  PRODUCT_VARIANTS_CURRENT: 'ProductVariantsCurrent',
  PRODUCT_VARIANTS_OUTLET: 'ProductVariantsOutlet',
  ITEM_COASTER_BRAKE: 'ItemCoasterBrake',
  PRODUCT_GEAR_TYPE: 'ProductGearType',
  STOCK: 'Stock',
  ARCHIVE_ITEM: 'ArchiveItem',
  PRODUCT_SEASON: 'ProductSeason',
  ITEM_SUPPLIER: 'ItemSupplier',
  ITEM_CASETTE_DESCRIPTION: 'ItemCasetteDescription',
  ITEM_CHAINWHEEL_DESCRIPTION: 'ItemChainwheelDescription',
  ITEM_TYPE: 'ItemType',
  ZZCA_CLIENT: 'ZzcaClient',
  PART_BRAND: 'PartBrand',
  // SITE_CONTROL: 'SiteControl',
  PRODUCT_ORDER_DATE: 'ProductOrderDate',
  PRODUCT_ORDER_CW: 'ProductOrderCW',
  PRODUCT_ORDER_PAYMENT_TARGET: 'ProductOrderPaymentTarget',
  PRODUCT_ORDER_DELIVERY: 'ProductOrderDelivery',
  PRODUCT_ORDER_BIKE_BRAND: 'ProductOrderBikeBrand',
  PRODUCT_ORDER_BRAND: 'ProductOrderBrand',
  PRODUCT_UPGRADE_BATTERY: 'ProductUpgradeBattery',
  PRODUCT_HEADSET: 'ProductHeadset',
  PRODUCT_NAME_INTERNAL: 'ProductNameInternal',
  ARTICLE_TYPE: 'ArticleType',
  CATEGORY: 'Category',
  PIM_CATEGORY: 'PimCategory',
  PRODUCT_SHOCK: 'ProductShock',
  UPGRADE_BATTERY_DATA: 'upgradeBatteryData',
}

export const SPEC_GROUPS = {
  SPEC_BRAKE: 'SpecBrake',
  SPEC_FRAME_SIZE: 'SpecFrameSize',
  SPEC_GROUPSET: 'SpecGroupset',
  SPEC_ITEM_CARRIER: 'SpecItemCarrier',
  SPEC_BATTERY: 'SpecBattery',
  SPEC_TRAVEL: 'SpecTravel',
  SPEC_HUB: 'SpecHub',
  SPEC_TIRE: 'SpecTire',
  SPEC_LEVER: 'SpecLever',
}

export const GROUP = {
  SELECTVARIANT: [TYPE.SELECT_COLOR, TYPE.SELECT_ITEM_GENDER_FRAME],
  COLOR: [
    TYPE.ITEM_COLOR,
    // TYPE.ITEM_COLOR_CODE,
    TYPE.ITEM_PRIMARY_COLOR_RGB,
    TYPE.ITEM_SECONDARY_COLOR_RGB,
    TYPE.ITEM_FILTER_COLOR,
    TYPE.COLOR_NAME_PRIMARY,
    TYPE.COLOR_FINISH_PRIMARY,
    TYPE.COLOR_NAME_SECONDARY,
    TYPE.COLOR_FINISH_SECONDARY,
  ],
  BASKET: [
    TYPE.PRODUCT_ORDER_CW,
    TYPE.PRODUCT_ORDER_DATE,
    TYPE.PRODUCT_ORDER_DELIVERY,
    TYPE.PRODUCT_ORDER_PAYMENT_TARGET,
    TYPE.PRODUCT_ORDER_BIKE_BRAND,
    TYPE.PRODUCT_ORDER_BRAND,
    TYPE.PRODUCT_UPGRADE_BATTERY,
  ],
  UPGRADES: [TYPE.UPGRADE_BATTERY_DATA],
  FRAMESIZE: [TYPE.ITEM_FRAME_SIZE_CODE],
  FRAMETYPE: [TYPE.ITEM_FRAME_TYPE, TYPE.ITEM_GENDER_FRAME],
  BRAND: [TYPE.PRODUCT_BRAND, TYPE.ITEM_BRAND],
  ARCHIVE: [TYPE.ARCHIVE_ITEM],
  BIDEXCODE: [TYPE.PRODUCT_BIDEX_COMMODITY_GROUP],
  PRODUCT_VARIANTS: [
    TYPE.PRODUCT_VARIANTS_CURRENT,
    TYPE.PRODUCT_VARIANTS_OUTLET,
    TYPE.ARCHIVE_ITEM,
    TYPE.ZZCA_CLIENT,
  ],
  [SPEC_GROUPS.SPEC_BRAKE]: [
    TYPE.PRODUCT_DISC_BRAKE_ROTOR_FRONT,
    TYPE.PRODUCT_DISC_BRAKE_ROTOR_REAR,
  ],
  [SPEC_GROUPS.SPEC_FRAME_SIZE]: [TYPE.ITEM_FRAME_SIZE_CODE, TYPE.ITEM_FRAME_SIZE_CM],
  [SPEC_GROUPS.SPEC_GROUPSET]: [TYPE.PRODUCT_GROUPSET, TYPE.PRODUCT_GEAR_SYSTEM_DESCRIPTION],
  [SPEC_GROUPS.SPEC_ITEM_CARRIER]: [TYPE.ITEM_CARRIER_FRONT, TYPE.ITEM_CARRIER_REAR],
  [SPEC_GROUPS.SPEC_BATTERY]: [TYPE.EBIKE_BATTERY_NAME, TYPE.ITEM_BATTERY_WATT_HOURS],
  [SPEC_GROUPS.SPEC_TRAVEL]: [TYPE.ITEM_TRAVEL_FORK, TYPE.ITEM_TRAVEL_FRAME],
  [SPEC_GROUPS.SPEC_HUB]: [TYPE.ITEM_FRONT_HUB, TYPE.ITEM_REAR_HUB],
  [SPEC_GROUPS.SPEC_TIRE]: [TYPE.ITEM_TIRE_DESCRIPTION, TYPE.ITEM_TIRE_REAR_DESCRIPTION],
  [SPEC_GROUPS.SPEC_LEVER]: [TYPE.PRODUCT_BRAKE_LEVER_DESCRIPTION, TYPE.PRODUCT_SHIFTER],
}

export const FILTER_ICONS = {
  [TYPE.ITEM_FRAME_TYPE]: {
    DROPDOWN: 'Diamond',
    // DI: 'Diamond',
    // CO: 'Comfort',
    // TR: 'Trapeze',
    // WA: 'Wave',
    // CP: 'Compact',
    // MI: 'Mixte',
    // DC: 'Connect',
    // CL: 'Classic',
    // UX: 'Ux',
    Diamond: 'Diamond',
    Comfort: 'Comfort',
    Trapez: 'Trapez',
    Wave: 'Wave',
    Compact: 'Compact',
    Mixte: 'Mixte',
    Connect: 'Connect',
    Classic: 'Classic',
    Ux: 'Ux',
  },
  [TYPE.ITEM_GENDER_FRAME]: {
    DROPDOWN: 'Diamond',
    // DI: 'Diamond',
    // CO: 'Comfort',
    // TR: 'Trapeze',
    // WA: 'Wave',
    // CP: 'Compact',
    // MI: 'Mixte',
    // DC: 'Connect',
    // CL: 'Classic',
    // UX: 'Ux',
    Diamond: 'Diamond',
    Comfort: 'Comfort',
    Trapez: 'Trapez',
    Wave: 'Wave',
    Compact: 'Compact',
    Mixte: 'Mixte',
    Connect: 'Connect',
    Classic: 'Classic',
    Ux: 'Ux',
  },
}

export const FILTER_ICON_NAMES = {
  [TYPE.ITEM_FRAME_TYPE]: {
    Diamond: 'DI',
    Comfort: 'CO',
    Trapez: 'TR',
    Wave: 'WA',
    Compact: 'CP',
    Mixte: 'MI',
    Connect: 'DC',
    Classic: 'CL',
    Ux: 'UX',
  },
  [TYPE.ITEM_GENDER_FRAME]: {
    Diamond: 'DI',
    Comfort: 'CO',
    Trapez: 'TR',
    Wave: 'WA',
    Compact: 'CP',
    Mixte: 'MI',
    Connect: 'DC',
    Classic: 'CL',
    Ux: 'UX',
  },
}

export const ARTICLE_TYPE = {
  BIKE: 'bike',
  SPAREPART: 'part',
  ACCESSORY: 'accessory',
}

export const SPEC_LIST = [
  TYPE.ITEM_BATTERY_RANGE,
  TYPE.ITEM_CHARGER_DESCRIPTION,
  TYPE.PRODUCT_ACCESSORIES,
  { [SPEC_GROUPS.SPEC_BRAKE]: GROUP[SPEC_GROUPS.SPEC_BRAKE] },
  TYPE.ITEM_PEDAL_DESCRIPTION,
  { [SPEC_GROUPS.SPEC_FRAME_SIZE]: GROUP[SPEC_GROUPS.SPEC_FRAME_SIZE] },
  TYPE.PRODUCT_DRIVE_TRAIN,
  { [SPEC_GROUPS.SPEC_GROUPSET]: GROUP[SPEC_GROUPS.SPEC_GROUPSET] },
  // TYPE.PRODUCT_BAREND,
  TYPE.PRODUCT_WHEELSET,
  TYPE.PRODUCT_KICKSTAND_DESCRIPTION,
  TYPE.ITEM_LOCK_DESCRIPTION,
  TYPE.PRODUCT_MAX_TOTAL_WEIGHT_KG,
  TYPE.ITEM_FRAME_DESCRIPTION,
  TYPE.PRODUCT_FRAME_STORAGE,
  TYPE.ITEM_FORK_DESCRIPTION,
  TYPE.ITEM_HANDLEBAR_DESCRIPTION,
  TYPE.ITEM_SADDLE_DESCRIPTION,
  TYPE.ITEM_SEATPOST_DESCRIPTION,
  TYPE.ITEM_STEM_DESCRIPTION,
  TYPE.PRODUCT_BRAKE_SYSTEM,
  TYPE.PRODUCT_CRANKSET,
  TYPE.PRODUCT_SHIFTER,
  TYPE.ITEM_ROTOR_DESCRIPTION,
  TYPE.BRAKE_FRONT_BRAKE_SYSTEM_DESCRIPTION,
  TYPE.ITEM_SPROCKET_DESCRIPTION,
  TYPE.ITEM_TRANSMISSION_OF_DRIVE,
  TYPE.ITEM_CASETTE_DESCRIPTION,
  TYPE.ITEM_CHAINWHEEL_DESCRIPTION,
  TYPE.PRODUCT_HEADSET,
  TYPE.ITEM_TIRE_DESCRIPTION,
  TYPE.ITEM_TIRE_REAR_DESCRIPTION,
  TYPE.PRODUCT_WHEEL_RIM_DESCRIPTION,
  TYPE.PRODUCT_BRAKE_LEVER_DESCRIPTION,
  TYPE.PRODUCT_REAR_BRAKE_DESCRIPTION,
  TYPE.PRODUCT_DISC_BRAKE_ROTOR_FRONT,
  TYPE.PRODUCT_DISC_BRAKE_ROTOR_REAR,
  { [SPEC_GROUPS.SPEC_ITEM_CARRIER]: GROUP[SPEC_GROUPS.SPEC_ITEM_CARRIER] },
  TYPE.PRODUCT_LIGHTS_FRONT_TYPE,
  TYPE.PRODUCT_LIGHTS_REAR_TYPE,
  { [SPEC_GROUPS.SPEC_BATTERY]: GROUP[SPEC_GROUPS.SPEC_BATTERY] },
  TYPE.EBIKE_DISPLAY_DESCRIPTION,
  TYPE.EBIKE_MOTOR_DESCRIPTION,
  TYPE.ITEM_COLOR,
  { [SPEC_GROUPS.SPEC_TRAVEL]: GROUP[SPEC_GROUPS.SPEC_TRAVEL] },
  { [SPEC_GROUPS.SPEC_HUB]: GROUP[SPEC_GROUPS.SPEC_HUB] },
  TYPE.PRODUCT_FENDER_DESCRIPTION,
  TYPE.ITEM_GRIP_DESCRIPTION,
  // TYPE.ITEM_LIGHTS_POWERED_BY,
  TYPE.PRODUCT_CHAINCASE_DESCRIPTION,
  TYPE.PRODUCT_REAR_DERAILLEUR,
  { [SPEC_GROUPS.SPEC_TIRE]: GROUP[SPEC_GROUPS.SPEC_TIRE] },
  TYPE.PRODUCT_BOTTOM_BRACKET,
  { [SPEC_GROUPS.SPEC_LEVER]: GROUP[SPEC_GROUPS.SPEC_LEVER] },
  TYPE.PRODUCT_WHEEL_SPOKE_DESCRIPTION,
  // TYPE.PRODUCT_STEER_BELL_DESCRIPTION,
  TYPE.PRODUCT_CHAIN_DESCRIPTION,
  TYPE.PRODUCT_FRONT_DERAILLEUR,
  TYPE.PRODUCT_SHOCK,
]

export default {
  TYPE,
  GROUP,
  SPEC_GROUPS,
  SPEC_LIST,
  FILTER_ICONS,
  FILTER_ICON_NAMES,
  ARTICLE_TYPE,
}
